// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"b5ca9bde","9743":"84eb0a3d"}[chunkId] + ".chunk.css";
};